import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';

export const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Заказы',
      description: 'Управление заказами',
      icon: '📦',
      route: '/admin/orders',
    },
    {
      title: 'Товары',
      description: 'Управление каталогом',
      icon: '🍱',
      route: '/admin/products',
    },
    {
      title: 'Категории',
      description: 'Управление категориями',
      icon: '📂',
      route: '/admin/categories',
    },
    {
      title: 'Пользователи',
      description: 'Управление пользователями',
      icon: '👥',
      route: '/admin/customers',
    },
    {
      title: 'Статистика',
      description: 'Аналитика и отчеты',
      icon: '📊',
      route: '/admin/statistics',
    },
  ];

  const handleMenuClick = (route: string) => {
    if (route === '/admin/orders' || route === '/admin/products' || route === '/admin/categories') {
      navigate(route);
    } else {
      // Остальные страницы еще не созданы
      alert(`Переход на ${route}\n(страница в разработке)`);
    }
  };

  const handleGoToApp = () => {
    navigate('/');
  };

  return (
    <div className="page admin-dashboard">
      <div className="admin-header">
        <h1 className="admin-title">Панель администратора</h1>
        <button className="go-to-app-btn" onClick={handleGoToApp}>
          Перейти в приложение
        </button>
      </div>

      <div className="admin-content">
        <div className="admin-menu">
          {menuItems.map((item) => (
            <button
              key={item.route}
              className="admin-menu-item"
              onClick={() => handleMenuClick(item.route)}
            >
              <div className="admin-menu-icon">{item.icon}</div>
              <div className="admin-menu-info">
                <h3 className="admin-menu-title">{item.title}</h3>
                <p className="admin-menu-description">{item.description}</p>
              </div>
              <div className="admin-menu-arrow">→</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
